<template>
  <div>
    <Modal
      v-model="conflictModal"
      title="冲突提示"
      footer-hide
    >
      <div v-for="(conflictItem, index) in list" :key="index" class="conflict-item">
        <div class="teacher-name">该课程教师{{ conflictItem.teacherName }}在本时段内已有排课！</div>
        <div v-for="(vosItem, index) in conflictItem.vos" :key="index" class="vos-item">
          <div class="name">学校名称: {{ vosItem.schoolName }}</div>
          <div class="name">课程名称: {{ vosItem.classroomName }}</div>
          <div class="name">上课时间: {{ vosItem.classTimeBegin.substring(11,16) }}~{{ vosItem.classTimeEnd.substring(11,16) }}</div>
        </div>
      </div>
      <div class="close-box">
        <Button @click="handleCloseConflictModal">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      conflictModal: false
    };
  },
  watch: {
    value(newVal, oldVal) {
      this.conflictModal = newVal;
    },
    conflictModal(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    handleCloseConflictModal() {
      this.conflictModal = false;
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-body{
  padding: 40px;
}
/deep/.close-box{
  display: flex;
  justify-content: center;
}
/deep/.conflict-item{
  margin-bottom: 30px;
  .teacher-name{
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: 600;
  }

  .vos-item{
    margin-bottom: 20px;
    .name{
      margin-bottom: 10px;
    }
  }
}
</style>

